import styled from 'styled-components';

import { Color } from '../../theme';

export const ContactDetail = styled.div`
  color: ${Color.darkGrey};
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 24px;

  a {
    color: ${Color.darkGrey};
  }
`;

export const ExternalLink = styled.a`
  text-decoration: none;
  color: ${Color.darkGrey};
`;
